<template>
  <div class="rounded border bg-white info-panel mb-3">
    <div class="text-gray-800 fw-bold px-6 py-3 fs-5 border-bottom">Информация</div>
    <div class="profile-info p-6" v-if="getUser">
      <div class="row">
        <div class="col-lg-6">
          <div class="border rounded p-5 mb-3">
            <div class="text-gray-500 mb-3">
              Логин:
              <span class="float-end text-gray-700 fw-bold" v-html="getUser.login"></span>
            </div>
            <div class="text-gray-500 mb-3">
              Ф.И.О:
              <span class="float-end text-gray-700 fw-bold" v-html="getUser.surname+' '+getUser.name+' '+getUser.patronymic"></span>
            </div>
            <div class="text-gray-500 mb-3">
              ИИН:
              <span class="float-end text-gray-700 fw-bold" v-html="getUser.iin"></span>
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="border rounded p-5 mb-3">
            <div class="text-gray-500 mb-3">
              Моб. телефон:
              <span class="float-end text-gray-700 fw-bold" v-html="getUser.phone"></span>
            </div>
            <div class="text-gray-500 mb-3">
              Эл. почта:
              <span class="float-end text-gray-700 fw-bold" v-html="getUser.email"></span>
            </div>
            <div class="text-gray-500 mb-3">
              День рождения:
              <span class="float-end text-gray-700 fw-bold" v-html="getUser.birthday"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Profile',
  computed: {
    getUser() {
      return this.$store.state.user
    }
  }
}
</script>

<style scoped>

</style>